import { useState } from 'react';

export const usePendingState = () => {
  const [pending, setPending] = useState<boolean>(false);

  return {
    pending,
    setPending,
  };
};
